// Localização: frontend/src/components/Prontuario/Profissional/RH/SalariosSection.jsx (versão 1.0.0)
// Seção de Salários do prontuário do profissional

import React, { useState, useEffect } from 'react';
import { Plus, DollarSign, Calendar, Edit } from 'lucide-react';
import { getSalarios, createSalario } from '../../../../api/api';
import { formatDate } from '../../../../utils/formatters';
import SalarioFormModal from './SalarioFormModal';

const SalariosSection = ({ profissionalId, onRefresh }) => {
    const [salarios, setSalarios] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isFormOpen, setIsFormOpen] = useState(false);

    useEffect(() => {
        fetchSalarios();
    }, [profissionalId]);

    const fetchSalarios = async () => {
        try {
            setLoading(true);
            const response = await getSalarios(profissionalId);
            if (response.data.success) {
                setSalarios(response.data.data || []);
            }
        } catch (error) {
            console.error('Erro ao buscar salários:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleCreateSuccess = () => {
        setIsFormOpen(false);
        fetchSalarios();
        if (onRefresh) onRefresh();
    };

    if (loading) {
        return (
            <div className="text-center py-8">
                <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-teal-600"></div>
            </div>
        );
    }

    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-semibold text-gray-900">Histórico de Salários</h3>
                <button
                    onClick={() => setIsFormOpen(true)}
                    className="flex items-center space-x-2 px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors"
                >
                    <Plus className="h-4 w-4" />
                    <span>Novo Salário</span>
                </button>
            </div>

            {salarios.length === 0 ? (
                <div className="text-center py-8 text-gray-500">
                    <DollarSign className="h-12 w-12 mx-auto mb-2 text-gray-400" />
                    <p>Nenhum salário registrado ainda.</p>
                </div>
            ) : (
                <div className="space-y-4">
                    {salarios.map((salario) => (
                        <div
                            key={salario.id}
                            className={`border rounded-lg p-4 ${
                                !salario.data_fim ? 'bg-teal-50 border-teal-200' : 'bg-gray-50 border-gray-200'
                            }`}
                        >
                            <div className="flex justify-between items-start">
                                <div className="flex-1">
                                    <div className="flex items-center space-x-2 mb-2">
                                        <DollarSign className="h-5 w-5 text-teal-600" />
                                        <span className="text-xl font-bold text-gray-900">
                                            R$ {parseFloat(salario.valor_salario || 0).toLocaleString('pt-BR', {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                            })}
                                        </span>
                                        {!salario.data_fim && (
                                            <span className="px-2 py-1 bg-teal-100 text-teal-800 text-xs font-medium rounded">
                                                Atual
                                            </span>
                                        )}
                                    </div>
                                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-2 text-sm text-gray-600">
                                        <div>
                                            <span className="font-medium">Início:</span>{' '}
                                            {formatDate(salario.data_inicio)}
                                        </div>
                                        {salario.data_fim && (
                                            <div>
                                                <span className="font-medium">Fim:</span>{' '}
                                                {formatDate(salario.data_fim)}
                                            </div>
                                        )}
                                        <div>
                                            <span className="font-medium">Tipo:</span> {salario.tipo_salario || 'N/A'}
                                        </div>
                                        {salario.carga_horaria_mensal && (
                                            <div>
                                                <span className="font-medium">Carga Horária:</span>{' '}
                                                {salario.carga_horaria_mensal}h/mês
                                            </div>
                                        )}
                                    </div>
                                    {salario.motivo_alteracao && (
                                        <div className="mt-2 text-sm text-gray-600">
                                            <span className="font-medium">Motivo:</span> {salario.motivo_alteracao}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            <SalarioFormModal
                isOpen={isFormOpen}
                onClose={() => setIsFormOpen(false)}
                profissionalId={profissionalId}
                onSuccess={handleCreateSuccess}
            />
        </div>
    );
};

export default SalariosSection;

